export * from "@gettactic/components/src/primitives/tooltip";
